import { css } from '@linaria/core'
import { themeColors } from '#styles/themes'

export const dimmed = css`
  color: ${themeColors.textDeselected};
`

export const pulsing = css`
  animation: 1s linear 0s infinite alternate pulse;

  @keyframes pulse {
    from {
      opacity: 1;
    }
    to {
      opacity: 0.33;
    }
  }
`
